"use client"
import { createContext, useContext, ReactNode } from "react"

const AppLocaleContext = createContext<string>("en")

interface AppLocaleProviderProps {
    locale: string
    children: ReactNode
}

export function AppLocaleProvider({ locale, children }: AppLocaleProviderProps) {
    return <AppLocaleContext.Provider value={locale}>{children}</AppLocaleContext.Provider>
}

export function useAppLocale() {
    return useContext(AppLocaleContext)
}

/**
 * Helper to build locale-aware URLs for app pages.
 * English uses root paths (/app/...), other locales use prefix (/{locale}/app/...)
 */
export function useLocalizedAppPath() {
    const locale = useAppLocale()

    return (path: string) => {
        if (locale === "en") {
            return path
        }
        return `/${locale}${path}`
    }
}
